export default __webpack_public_path__ + "static/media/LightBlue0000.4205836f.png";